module.exports = __webpack_public_path__ + "static/kitze-small-c904f5f16eb682faf302c3848ec4659e.png";